// extracted by mini-css-extract-plugin
module.exports = {"CertificateUpload":"CertificateUpload_CertificateUpload__1HwnG"};